import {Overlay, OverlayConfig, OverlayRef} from "@angular/cdk/overlay";
import {CdkPortal, Portal} from "@angular/cdk/portal";
import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Subscription} from "rxjs";
import {DialogModel} from "../../models/components/dialog.model";
import {DialogService} from "../../services/components/dialog.service";
import {ObservableOnDestroyMixin} from "../../mixins/observable-on-destroy.mixin";
import {EmptyMixin} from "../../mixins/empty.mixin";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: "pcg-ng-dialog",
    template: require('./dialog.component.html')
})
export class DialogComponent extends ObservableOnDestroyMixin(EmptyMixin) implements OnInit, OnDestroy {

    @ViewChild("layout", {read: CdkPortal})
    public layout: CdkPortal;
    @ViewChild("modal") public modalRef: ElementRef;

    public content: Portal<any>;
    private overlayRef: OverlayRef;

    public constructor(
        private overlay: Overlay,
        private dialogService: DialogService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.dialogService.dialogObservable
            .pipe(takeUntil(this.destroy$))
            .subscribe((dialog) => {
                this.show(dialog);
                this.dialogService.focus();
            });
    }

    public ngOnDestroy(): void {
        if(this.overlay) {
            this.overlayRef.dispose();
        }
    }

    private createOverlayRef(config: OverlayConfig): OverlayRef {
        const overlayRef = this.overlay.create(config);
        overlayRef.backdropClick().subscribe(this.hide);

        return overlayRef;
    }

    private show = (dialog: DialogModel) => {
        this.cleanUp();

        if(dialog) {
            this.overlayRef = this.createOverlayRef(dialog.config);
            this.content = dialog.portal;
            this.overlayRef.attach(this.layout);

            setTimeout(() => {
                this.modalRef.nativeElement.focus();
            });
        }
    }

    public hide = (): void => {
        this.dialogService.hide();
    }

    private cleanUp(): void {
        if (this.overlayRef && this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
            this.overlayRef.dispose();
        }
    }

    @HostListener("document:keyup.escape", ["$event"]) public onEscapePressed(event: KeyboardEvent): void {
        this.hide();
    }
}
